import {BaseContainerModel} from "../../base-container.model";
import {
  bl_wf_attachment_hdr_RowInterface,
  bl_wf_attachment_hdr_RowClass,
  bl_wf_attachment_ext_RowClass
} from "../../../dbschema";

export class WfAttachmentContainerModel extends BaseContainerModel {
  bl_wf_attachment_hdr: bl_wf_attachment_hdr_RowInterface = new bl_wf_attachment_hdr_RowClass();
  bl_wf_attachment_exts: bl_wf_attachment_ext_RowClass[] = [];
}
